<form [formGroup]="editPaymentForm" class="pmt">
  <div class="pmt-title">
    {{'CONTRACTS.CARD.PAYMENT.DETAILS'|translate}}
  </div>
  <mat-form-field  class="form-field-cs" floatLabel="always" hideRequiredMarker="true">
    <mat-icon matPrefix svgIcon="user-shared-fill" class="form-field-icon"></mat-icon>
    <mat-label>{{'CONTRACTS.CARD.PAYMENT.PAYER' | translate}}</mat-label>
    <mat-select [formControl]="payer_guid" disableRipple panelClass="payment-select-panel" placeholder="Выбрать">
      <mat-option [value]="null">{{'CONTRACTS.CARD.PAYMENT.UNKNOWN_PARTY' | translate}}</mat-option>
      @for (party of fromParties; track party) {
        <mat-option [value]="party.guid">{{party.name}}</mat-option>
      }
    </mat-select>
    @if (payer_guid.hasError('required')) {
      <mat-error>{{'VALIDATION.REQUIRED' | translate}}</mat-error>
    }
  </mat-form-field>
  
  <mat-form-field  class="form-field-cs" floatLabel="always" hideRequiredMarker="true">
    <mat-icon matPrefix svgIcon="user-received-2-fill" class="form-field-icon" ></mat-icon>
    <mat-label>{{'CONTRACTS.CARD.PAYMENT.RECIPIENT' | translate}}</mat-label>
    <mat-select [formControl]="recipient_guid" disableRipple  panelClass="payment-select-panel" placeholder="Выбрать">
      <mat-option [value]="null">{{'CONTRACTS.CARD.PAYMENT.UNKNOWN_PARTY' | translate}}</mat-option>
      @for (party of toParties; track party) {
        <mat-option [value]="party.guid">{{party.name}}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field style="width: 100%;" class="form-field-cs" floatLabel="always">
        <mat-icon matPrefix svgIcon="wallet-2-fill" class="form-field-icon"></mat-icon>
      <mat-label>{{'CONTRACTS.CARD.PAYMENT.AMOUNT' | translate}}</mat-label>
      <input matInput formControlName="total" autocomplete="disabled" placeholder="0">
      <mat-error *ngIf="total?.errors?.['pattern']">{{ 'VALIDATION.FORMAT' | translate}} </mat-error>
      <mat-error *ngIf="total?.errors?.['required']">{{ 'VALIDATION.REQUIRED' | translate}}</mat-error>
  </mat-form-field>

  <div class="pmt-button-block">
    <button 
      [disabled]="editPaymentForm.invalid"
      (click)="addPaymentToStep()"  class="button-icon size-xxl primary-button" type="submit" >
      <mat-icon svgIcon="checkbox-fill"></mat-icon>
      {{('CONFIRM.BUTTONS.CONFIRM'|translate) }}
    </button>
    <button (click)="cancelAction()" class="button-icon size-xxl secondary-button">
      <mat-icon svgIcon="close-fill"></mat-icon>
      {{ 'CONFIRM.BUTTONS.CANCEL'|translate }}
    </button>
  </div>
</form>

